import Depanneuse from '@amo/core/assets/images/icons/Depanneuse.png';
import { Question } from '@amo/core/components/containers';
import { Radio } from '@amo/core/components/forms';
import _ from 'lodash';
import { Field } from 'redux-form';
import {getTranslation} from "../../../utils/index.js";

export const Remorquage = (props) => {
    const { nextQuestion, data } = props;

    return (
        <Question asFieldset required
            icon={Depanneuse}
            title={getTranslation('yourNeedes.towingVehicle.title')}
            subtitle={getTranslation('yourNeedes.towingVehicle.subtitle')}
            position={'bottom'}
        >
            <div className={'row justify-content-center'}>
                <div className={'col-lg-4 col-md-6 col-sm-6 col-6 my-2'}>
                    <Field
                        component={Radio}
                        type={'radio'}
                        name={'DemandeTarif[DevoirConseil][DevoirASS2]'}
                        value={'1'}
                        label={getTranslation('yes')}
                    />
                </div>
                <div className={'col-lg-4 col-md-6 col-sm-6 col-6 my-2'}>
                    <Field
                        component={Radio}
                        type={'radio'}
                        name={'DemandeTarif[DevoirConseil][DevoirASS2]'}
                        value={'0'}
                        label={getTranslation('no')}
                    />
                </div>
            </div>

            <button
                className={`btn btn-primary btn-arrow mt-4 ${
                    !_.get(data, 'DemandeTarif[DevoirConseil][DevoirASS2]') && 'disabled'
                }`}
                onClick={() => nextQuestion()}
            >
                {getTranslation('continue')}
            </button>
        </Question>
    );
};
